export default __webpack_public_path__ + "static/media/logo2.ce977b50.png";